export default __webpack_public_path__ + "static/media/money-back@2x.cb54a2e7.png";